import React, { FC } from 'react';
import NotesView from 'components/shared/detail/NotesView';
import AccordionWidgetIcon from 'app/modules/posts/components/accordionWidget/AccordionWidgetIcon';
import AccordionWidget from 'app/modules/posts/components/AccordionWidget';
import AccordionWidgetTitle from 'app/modules/posts/components/accordionWidget/AccordionWidgetTitle';
import { Chip } from '@kontentino/ui';
import { PostDetail } from 'types/PostDetail';
import { HyperText } from '@kontentino/kontentino-post-previews';

type Props = {
  note?: PostDetail['noteWithMentions'];
  isError: boolean;
  isLoading: boolean;
  accordionProps?: Partial<React.ComponentProps<typeof AccordionWidget>>;
};

const Notes: FC<Props> = ({ note, isError, isLoading, accordionProps }) => {
  return (
    <AccordionWidget
      icon={<AccordionWidgetIcon variant="notes" />}
      title={<AccordionWidgetTitle variant="notes" />}
      titleSuffix={(isOpen) =>
        !isOpen &&
        !!note?.text &&
        note.text?.length > 0 && (
          <Chip className="tw-bg-grayscale-10">
            <HyperText
              className="!tw-whitespace-nowrap !tw-text-black"
              options={{
                ellipsis: true,
                maxLength: 50,
                mentionedUsers: note?.mentionedUsers || [],
              }}
            >
              {note.text}
            </HyperText>
          </Chip>
        )
      }
      {...accordionProps}
    >
      <NotesView
        isError={isError}
        isLoading={isLoading}
        note={note}
        dataCy="post-detail-note-value"
      />
    </AccordionWidget>
  );
};

export default Notes;
